import React from 'react';
import Counselling from "../../Assets/Images/counselling-therapy4.jpg";
import Counselling1 from "../../Assets/Images/counselling-therapy1.png";
import Counselling2 from "../../Assets/Images/counselling-therapy2.webp";
import Counselling3 from "../../Assets/Images/counselling-therapy3.jpg";
import { IoIosArrowForward } from 'react-icons/io';

const Services = () => {
  return (
    <>
      {/* Hero Section */}
      <div
        className="min-h-[500px] sm:min-h-[600px] md:min-h-[500px] lg:h-[90vh] bg-cover bg-no-repeat bg-right relative shadow-lg px-4 sm:px-6 md:px-[5%] mt-10"
        style={{ backgroundImage: `url(${Counselling})` }}
        data-aos="flip-left"
        data-aos-delay="200"
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        <div className="relative z-10 flex flex-col items-center justify-center text-center py-16 sm:py-24 md:py-32 px-2 sm:px-6 max-w-4xl mx-auto">
          <p className="text-white font-bold text-2xl sm:text-3xl md:text-4xl font-serif leading-relaxed">
            Find personalized <span className="text-accent">mental health</span><br className="hidden sm:block" />
            support designed just for you
          </p>
          <p className="mt-4 text-white/85 text-sm sm:text-base md:text-lg">
            Seeking psychiatric support can feel overwhelming. Our dedicated and experienced psychiatrists<br className="hidden md:block" />
            prioritize your well-being, guiding you with care and understanding throughout your recovery journey.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mt-6">
            <button className="bg-primary hover:scale-90 transition duration-300 text-white px-4 py-2 rounded-sm shadow">
              Book Appointment
            </button>
            <button className="border border-primary hover:scale-90 transition duration-300 text-accent px-4 py-2 rounded-sm shadow">
              Contact
            </button>
          </div>
        </div>
      </div>


      {/* Services Title */}
      <div className='flex justify-center items-center mt-10'>
        <h3 className="bg-primary/20 text-xl text-accent px-5 py-1 font-semibold rounded-3xl">
          Services
        </h3>
      </div>

      {/* Services Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-4 sm:px-6 md:px-[5%] mt-10 mb-20">
        {[{
          title: "Counselling",
          slogan: "Find clarity and direction.",
          image: Counselling1
        }, {
          title: "Therapies",
          slogan: "Heal and grow with care.",
          image: Counselling2
        }, {
          title: "Psychiatry",
          slogan: "Support for workplace well-being.",
          image: Counselling3
        }].map(({ title, slogan, image }, index) => (
          <div
            key={index}
            className="relative rounded-lg overflow-hidden shadow-lg border-2 border-primary h-72 sm:h-80 md:h-[22rem] lg:h-[26rem]"
          >
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
            <div className="absolute inset-0 bg-black/50 flex flex-col justify-end p-4">
              <h3 className="text-lg font-semibold text-lime-500">{title}</h3>
              <p className="text-white text-sm">{slogan}</p>
              <div className='flex justify-start items-center mt-3 bg-accent w-fit text-white text-sm px-4 py-2 rounded-md shadow hover:scale-90 transition duration-300'>
                <button className="text-base font-medium">
                  Know More
                </button>
                <IoIosArrowForward className='text-base font-medium ml-2' />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Services;



